<template>
  <div class="page__content page__content_regular">
    <div class="page__nav">
      <div
        class="page__nav-btn-back"
        @click.prevent="$router.push({name: 'settings'})"
      />
    </div>
    <div class="blocks page__content-blocks">
      <NewPasswordForm
        description="Длина пароля должна быть от 8 до 30 символов. Пароль должен содержать цифры и латинские буквы в верхнем и нижнем регистрах, не должен содержать пробелов. Рекомендуем использовать спецсимволы в пароле."
      />
    </div>
  </div>
</template>

<script setup>
import NewPasswordForm from '@/components/settings/entities/newPasswordForm.vue';
</script>

<style scoped>

</style>
